var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRefresh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 20,
    viewBox: "235.08 -728 493.46 496",
    width: 20,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M483.08-232q-103.25 0-175.63-72.34-72.37-72.34-72.37-175.54t72.37-175.66Q379.83-728 483.08-728q67.3 0 122.04 32.38 54.73 32.39 87.8 85.08V-728h32v169.23H555.69v-32h111q-28.23-47.85-76.38-76.54Q542.15-696 483.08-696q-90 0-153 63t-63 153 63 153 153 63q84 0 144-55.5t69-136.5h32.46q-7.46 95.85-77.54 159.92Q580.92-232 483.08-232"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh);
export default __webpack_public_path__ + "static/media/refresh.4cc30ac711b80538642bbe15b9aeac9a.svg";
export { ForwardRef as ReactComponent };